import { PersonBio } from "@/services/DTOs/PersonBio";

export interface ICandidateBio {
  person: PersonBio;
}

export class CandidateBio {
  public person: PersonBio;

  constructor(data: ICandidateBio) {
    this.person = new PersonBio(data.person);
  }
}
